/**
 * Copyright IBM Corp. 2022, 2026
 */

import s from './topic-content.module.css'

export default function TopicContent({ content }) {
	return (
		<div className={s.container}>
			<h4 className="g-type-display-4">Details</h4>
			<div
				className={s.contentContainer}
				dangerouslySetInnerHTML={{ __html: content }}
			/>
		</div>
	)
}
